// 此文件提取的是运行页的数据相关代码, 暂时不考虑审核. 该文件也未被引用.

// 归档
// 赋值, 取值
// 计算，需访问跨级数据, 不依赖控件, 根据数据关系图确定我能访问的数据
// 关联，需访问跨级数据
// 事件
// 校验, 依附于控件

// 聚合模型易于理解，在绑定控件、赋值、取值易于使用，但不利于数据监听访问。
// 1. 如何设置监听 ?
// 2. 不归档的容器控件, 和不归档的控件
// 关系模型, 使组件产生数据模型的依赖，但容易全局访问监听数据。
// 1. 如何传递索引 ?

// 如何检索模型 ?
// 表格的数据如何监听 ?
// 树组件的数据模型 ?

// 表单嵌套
// 其他控件的值可以作为属性
// 控件的行为受制于父组件
// 表格控件的校验
// 表达式编辑器及弹窗复用
// 栅格布局
// 前端对象之间的关系到后台能依旧保持, 重复的实例只创建一次.

/*
 * 子组件的数据有父组件管理, 暂时由父组件决定子组件的类型来分配数据.
 *
 */

// event bus
import Vue from 'vue'
import { UUID } from '@/plugins/common'

class DataService {
  schema = {}
  data = {}

  constructor (args = {}) {
    this.schema = {}
    this.data = {}
  }

  // 构建
  // dataState: 表单暂存所有的dataState不需要修改为update
  buildModel (mainTable, loadedData, holdDataState) {
    const root = this.schema.tables.find(m => m.tableId === mainTable)

    return this.buildData(root, loadedData, holdDataState)
  }

  buildData (table, loadedData, holdDataState) {
    const data = {}

    if (!loadedData) {
      Vue.set(data, 'id', UUID.create())
      Vue.set(data, 'dataState', 'create')
    } else {
      Vue.set(data, 'id', loadedData['id'])
      let dataState = loadedData['dataState']

      // 为了解决暂存，存初始状态
      Vue.set(data, 'dataStateInit', dataState)

      if (!dataState || dataState === 'create') {
        dataState = 'update'
      }
      if (holdDataState) {
        dataState = holdDataState
      }
      Vue.set(data, 'dataState', dataState)
    }

    for (const column of table.columns) {
      if (loadedData) {
        Vue.set(data, column.id, loadedData[column.id])
      } else {
        Vue.set(data, column.id, '')
      }

      if (column.primaryKey) {
        Vue.set(data, column.id, data.id)
      }
    }

    this.schema.relations.filter(m => m.primaryTable === table.tableId).forEach(m => {
      let value
      const destTable = this.schema.tables.find(t => t.tableId === m.foreignTable)
      if (m.type === 'one2one') {
        if (loadedData) {
          value = this.buildData(destTable, loadedData[m.id], holdDataState)
        } else {
          value = this.buildData(destTable, undefined, holdDataState)
        }
      } else {
        value = []
        if (loadedData && loadedData[m.id] && loadedData[m.id].length > 0) {
          loadedData[m.id].forEach(n => {
            value.push(this.buildData(destTable, n, holdDataState))
          })
        }
      }
      Vue.set(data, m.id, value)
    })

    return data
  }

  // 操作
  addRow (table, rows) {
    rows.push(this.buildData(table))
  }

  buildSubmitData (component) {
    let data = this.data
    Object.keys(data).forEach(key => {
      // 如果值是数组类型的, 说明是一个表格或者其他一对多的东西
      if (key.indexOf('var_') < 0 && data[key] instanceof Array && !key.includes('countersignUser')) {
        // 临时变量, 下面会使用到
        let tempData = data[key][0]
        // 过滤出数组中所有值都是空的东西
        data[key] = data[key].filter(m => {
          let flag = false
          for (let index in m) {
            // fixme: 这个地方为了方便直接只判断了 UUID 的值是否为空, 以后如果有其他的情况, 请注意修复
            if (m[index] && index.length > 32 && m[index] !== '' && m[index] !== m.id) {
              flag = true
              break
            }
          }
          return flag
        })
        if (!data[key] || data[key].length === 0) {
          // 判断, 假如表格中没有填写任何东西, 但是表格中的控件存在必填属性, 则在表格中增加一个一类数据, 给表单校验使用, 赋值内容为上面克隆出来的临时变量
          let table = component.find(m => m.archive.relationId === key) || component.find(m => m.archive.tableId === key)
          if (table && table.children) {
            let children = table.children
            for (let index in children) {
              if (children[index].properties.required) {
                if (tempData) {
                  data[key].push(tempData)
                }
                break
              }
            }
          }
        }
      }
    })
  }
}

let methods = {
  update (value) {
    this.$emit('input', { child: this, value: value })
  },
  updateChildValue ({ child, value }) {
    // 更新子控件的值
    let dataService = this.getLineDataByIndex(child.index)
    let columnId = child.component.columnId
    this.$store.commit('formRuntime/setDataValue', { data: dataService, value, columnId })
  },
  getTableData () {
    // 负责获取当前表 or 表单的数据
    return this.$store.getters['formRuntime/getData'](this.component.tableId)
  },
  getLineDataByIndex (index) {
    // 根据索引获取到当前行的数据
    return this.getTableData[index]
  },
  getComponetnValue (component, index) {
    // 获取子控件的值
    if (component.columnId && this.getTableData) {
      if (this.getLineDataByIndex(index)) {
        return this.getLineDataByIndex(index)[component.columnId]
      }
    }
  },

  // 初始化
  initCal (calculate) {
    let expression = calculate.calculationPanelData.expression
    let data = this.$store.state.formRuntime.data
    let parameter = this.getColumnIds(calculate.calculationPanelData.expression)
    parameter.forEach(columnId => {
      this.$watch(() => {
        let tableId = this.findTableId(columnId)
        let tableType = this.$store.getters['formRuntime/getTableType'](tableId)
        // 表格监听
        if (tableType === 'table') {
          let index = parseInt(this.$el.parentNode.parentNode.parentNode.firstElementChild.textContent) - 1
          return data[tableId][index + 1][columnId]
          // 一般控件监听
        } else if (tableType === 'form') {
          return data[tableId][1][columnId]
        }
      }, (val, old) => {
        this.implementCalculation(expression)
      })
    })
  },
  // 从公式获取id组
  getColumnIds (expression) {
    let reg = /\$\{(.+?)\}/g
    let result = expression.match(reg) || []
    return result.map(n => n.substring(2, 38))
  },
  // columnId获取TableId
  findTableId (columnId) {
    let data = this.$store.state.formRuntime.data
    let result = ''
    for (let tableId in data) {
      if (result) {
        break
      }
      for (let i = 0, length = data[tableId].length; i < length; i++) {
        if (data[tableId][i].hasOwnProperty(columnId)) {
          result = tableId
          break
        }
      }
    }
    return result
  },
  // 实现计算
  initDefaultValue () {
    // 初始化默认值
    if (!(this.component.attr.default && this.component.attr.default.enable)) {
      return true
    }
    let defaultValue
    // 计算暂时用不到
    // let calculatine = this.component.attr.default.calculatine
    if (this.component.attr.default.defaultValue) {
      defaultValue = this.component.attr.default.defaultValue
    }
    if (this.component.attr.default.useComponentId) {
      let useComponent = this.$store.getters['formRuntime/getComponentById'](this.component.attr.default.useComponentId)
      let useDataModel = this.$store.getters['formRuntime/getData'](useComponent.tableId)
      if (useDataModel) {
        // 选中的控件不能是带有多行容器的控件
        defaultValue = useDataModel[0][useComponent.columnId]
      }
    }

    let dataModel = this.$store.getters['formRuntime/getData'](this.component.tableId)
    if (dataModel && defaultValue) {
      let columnId = this.component.columnId
      let data = dataModel[this.index]
      let value = defaultValue
      this.$store.commit('formRuntime/setDataValue', { data, value, columnId })
    }
  },
  rulesData () {
    let result = this.$store.getters['formRuntime/getData'](this.component.tableId)
    if (result && result.length) {
      return result[0]
    }
  }
}

// 归档
// 赋值, 取值
// 计算，需访问跨级数据, 不依赖控件, 根据数据关系图确定我能访问的数据
// 关联，需访问跨级数据
// 事件
// 校验, 依附于控件

// 聚合模型易于理解，在绑定控件、赋值、取值易于使用，但不利于数据监听访问。
// 1. 如何设置监听 ?
// 2. 不归档的容器控件, 和不归档的控件
// 关系模型, 使组件产生数据模型的依赖，但容易全局访问监听数据。
// 1. 如何传递索引 ?

// 如何检索模型 ?

// 表单嵌套
// 其他控件的值可以作为属性
// 控件的行为受制于父组件
// 表格控件的校验
// 表达式编辑器及弹窗复用
// 栅格布局
// 前端对象之间的关系到后台能依旧保持, 重复的实例只创建一次.
export { methods }
export default DataService



// WEBPACK FOOTER //
// ./src/store/form-runtime/dataService.js